'use strict';

export default function chartConfig(scope) {
  'ngInject';

  let chartConfig = {
    chart: {
      type: 'column',
      height: 300,
      events: {
        load: function () {
          // Highcharts オブジェクトへの参照をコンパクトに実現するため、arrow function を用いない
          scope.chart = this;
        }
      }
    },
    colors: ['#2b908f'],
    title: {text: '1日毎の電力量料金'},
    xAxis: {
      categories: scope.categories,
      crosshair: true,
      labels: {
        formatter: function() {
          let style = '';
          let day = scope.filter('dayFilter')(this.value);
          if(day === '日') {
            style = 'color: #ff3131';
          } else if(day === '土') {
            style = 'color: #3737ff';
          }

          return `<span style="${style}">${scope.filter('date')(this.value, 'M/d')} (${day})</span>`;
        }
      }
    },
    yAxis: {
      labels: {
        format: '{value}'
      },
      title: {
        text: '電力量料金 [円]'
      }
    },
    legend: {enabled: false},
    tooltip: {
      enabled: true,
      shared: true,
      followPointer: true,
      formatter: function () {
        let tip_format = "<tspan style='font-size: 12px'>" + scope.filter('date')(this.x, 'MM月dd日') + "</tspan>";

        let point = this.points[0];
        tip_format += '<br/><span style="color:' + point.series.color + ';font-size: 12px">\u25CF</span> <span style="font-size: 14px;">' + point.series.name + ': ';
        tip_format += scope.filter('decimalFilter')(point.y, 1) + " 円";
        tip_format += "</span>"

        return tip_format;
      }
    },
    plotOptions: {column: {grouping: false}},
    series: [
      {
        name: '電力量料金',
        color: '#FFC107'
      }
    ]
  };

  return chartConfig;
}



// WEBPACK FOOTER //
// ./public/dev/app/price_report/monthly/monthly_price_report.config.js